export const ADMIN_ROUTES = {
  IT_SECURITY: 'it',
  DEVELOPER_TOOLS: {
    MAIN: 'developer_tools',
    SERVICE_ACCOUNTS: 'service_accounts',
    EVENT_SETTINGS: 'event_settings',
    POLICY_API_CONFIG: 'policy_api_config',
    VENDOR_API_PROFILES: 'vendor_api_profiles',
    HOOK_ENDPOINTS: 'hook_endpoints',
  },
  FEATURES: 'features',
  ORGANIZATION: {
    MAIN: 'organization',
    ADJUSTERS: 'adjusters',
    INSURED_PROPERTIES: 'insured_properties',
    ORGANIZATION_EMAILS: 'organization_emails',
    SPECIAL_USERS: 'special_users',
    SPECIAL_CONTACTS: 'special_contacts',
    SPECIAL_USER_LISTS: 'special_user_lists',
    ORGANIZATION_COUNTRIES: 'organization_countries',
    ORGANIZATION_LINES_OF_BUSINESSES: 'organization_lobs',
    CLAIM_NUMBERING_SCHEME: 'claim_numbering',
    CATASTROPHIC_EVENTS: 'catastrophic_events',
  },
  AUTOMATION: {
    MAIN: 'automation',
    ASSIGNMENTS: 'assignments',
    EXPOSURES: 'exposures',
    COMMUNICATIONS: 'communications',
    NOTIFICATIONS: 'notifications',
    WORKFLOWS: 'workflows',
    GUARDRAILS: 'guardrails',
    FUND_ACCOUNTS: 'fund_accounts',
    SLA_ENGINE: 'sla_engine',
  },
  COVERAGES: {
    MAIN: 'coverages',
    COVERAGES: 'coverages',
    COVERAGES_GROUPS: 'groups',
  },
  TRIAGE_RESERVES: 'reserves',
  INTEGRATIONS: 'integrations',
  VENDORS: 'vendors',
  COMMUNICATIONS: 'communications',
  GENERAL_EMAIL_CONFIG: 'general_email_config',
  LOGIN_CONFIGURATION: 'login_configuration',
  MOI_CONFIG: 'moi_config',
  EXPOSURE_CONFIG: 'coverage_config',
  DAMAGE_ASSESSMENT_TYPES: 'damage_assessment_types',
  INVOICE_CONFIGURATION: 'invoice_configuration',
  INCIDENT_CONFIG: 'incident_config',
  PAYMENTS_CONFIGURATION: 'payments_configuration',
  PERMISSION_PROFILES: 'permission_profiles',
  TABLEAU_ACCOUNTS: 'tableau_accounts',
  CLAIM_CONFIG: {
    MAIN: 'claim_config',
    CLOSING_REASON: 'closing_reason',
    CLAIM_BAR_CONFIGURATION: 'claim_bar_configuration',
    CLAIM_SIDEBAR_CONFIGURATION: 'claim_sidebar_configuration',
    CLAIM_STAGE_CONFIGURATION: 'claim_stage_configuration',
    CLAIM_FLAG_CONFIGURATION: 'claim_flag_configuration',
    CLAIM_MILESTONE_CONFIGURATION: 'claim_milestone_configuration',
  },
  FNOL_CONFIGURATION: 'fnol_configuration',
  POLICY_CONFIGURATION: 'policy_configuration',
  GENERIC_TEMPLATES_CONFIGURATION: 'generic_templates_configuration',
  CONTACT_ROLES: 'contact_roles',
  DOCUMENT_TYPES: 'document_types',
  NOTES_CONFIG: 'notes_configuration',
  STAT_RESERVES: 'stat_reserves',
  DEMO_CONFIGURATION: {
    MAIN: 'demo_configuration',
    CLAIMS: 'claims',
    CLIVE_DEMO_FEATURE_FLAGS: 'clive_demo_feature_flags',
    CLIVE_DEMO_CONFIGURATION: 'demo_feature_flags',
  },
  CLIVE_CONFIGURATION: {
    MAIN: 'clive_configuration',
    ACCOUNT: 'account',
    CONFIGURATION: 'configuration',
    FNOL: 'fnol',
    FEATURES: 'features',
    DEMOS: 'demos',
    FEATURE_FLAGS: 'feature_flags',
    AGENT_CONFIGURATION: 'agent_configuration',
    QA_CONFIGURATION: 'qa_configuration',
    EXTERNAL_TOOL_APIS: 'external_tool_apis',
    PREDEFINED_PROMPTS: 'predefined_prompts',
  },
  NOTIFICATIONS_CONFIGURATION: {
    MAIN: 'notifications_configuration',
    CATEGORIES: 'categories',
    PREFERENCES: 'preferences',
    KANBAN: 'kanban',
  },
  N8N_CONFIGURATION: {
    MAIN: 'n8n_configuration',
  },
  E_SIGN_CONFIGURATION: {
    MAIN: 'e_sign_configuration',
  },
  GLOBAL_CONFIGURATION: {
    MAIN: 'global_configuration',
    POLICY: 'policy',
    FNOL: 'fnol',
    CATEGORIES: 'categories',
  },
  INTERNAL_AUDIT_LOG: 'internal_audit_log',
  DELEGATED_AUTHORITY: 'delegated_authority',
  DATA_IMPORT: 'data_import',
};
